<div class="main">
  <div class="main__section">
    <div class="main__body initial-fade-up-animate">
      <div class="main__body_head-titles">
        <div class="main__body_headline-titles">
          <p class="main__body_headline">
            {{ 'general.exclusive' | translate }}
            <br />
          </p>

          <rp-home-marquee />
        </div>

        <h1 class="main__body_title">Riddick's Partners</h1>
      </div>

      <div class="main__body_subtitle">
        {{ 'main.subTitle' | translate }}
        <br />
        {{ 'main.subTitle2' | translate }}
      </div>

      @let isDesktop = isDesktop$ | async;

      <div class="main__body_actions">
        <ui-button
          withBorder
          withLabelPaddings
          [label]="'general.webmaster' | translate"
          appereance="secondary"
          [fullWidth]="!isDesktop"
          size="l"
          routerLink="/{{ routes.signUpWebmaster }}"
          [queryParams]="{ to: '/' }"
        />

        <ui-button
          withBorder
          withLabelPaddings
          [label]="'general.advertiser' | translate"
          appereance="primary"
          [fullWidth]="!isDesktop"
          size="l"
          routerLink="/{{ routes.signUpAdvertiser }}"
          [queryParams]="{ to: '/' }"
        />
      </div>

      <rp-home-socials />
    </div>

    <img
      class="main__hero"
      width="485"
      src="https://cdn.prod.website-files.com/671e698830f91cc201998012/671e8e6931fee82d134d2ed0_tv-hero%402x.png"
      srcset="
        https://cdn.prod.website-files.com/671e698830f91cc201998012/671e8e6931fee82d134d2ed0_tv-hero%402x-p-500.png 500w,
        https://cdn.prod.website-files.com/671e698830f91cc201998012/671e8e6931fee82d134d2ed0_tv-hero%402x-p-800.png 800w,
        https://cdn.prod.website-files.com/671e698830f91cc201998012/671e8e6931fee82d134d2ed0_tv-hero%402x.png       970w
      "
      alt="tv-hero"
      sizes="(max-width: 479px) 55vw, (max-width: 991px) 47vw, 485px"
    />
  </div>
</div>
